<template>
  <div class="row">
    <div class="col-8 text-start">
      <b>Settings Found</b>
      <hr />
      <div
        :key="key"
        v-for="{ key, value } in keysFound"
        class="row d-flex justify-content-between"
      >
        <div class="col">{{ key }}</div>
        <div class="col text-end text-truncate">{{ value }}</div>
      </div>
    </div>
    <div class="col text-start">
      <b>Settings Missing</b>
      <hr />
      <div
        :key="key"
        v-for="{ key } in keysMissing"
        class="row d-flex justify-content-between"
      >
        <div class="col">{{ key }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useSettingsStore } from "@/dev/store/useSettingsStore.js";
import { mapState } from "pinia";
export default {
  name: "TheSettingsManager",
  computed: {
    ...mapState(useSettingsStore, ["keysFound", "keysMissing"])
  }
};
</script>
